(() => {
  // Enforce min=25 on any product page with the MOQ25 flag.
  const applyMOQ = () => {
    if (document.documentElement.dataset.moq25 !== 'true') return;

    // Zepto renders its own form. Grab whichever quantity field exists.
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const qty =
      form.querySelector('input[name="quantity"]') ||
      document.querySelector('input.quantity__input[name="quantity"]');

    if (!qty) return;

    qty.min = 25;
    qty.step = 1; // no forced increments
    if (!qty.value || Number(qty.value) < 25) qty.value = 25;

    // Clamp manual edits
    qty.addEventListener('change', () => {
      const v = Number(qty.value || 0);
      if (isNaN(v) || v < 25) qty.value = 25;
    });

    // Guard add-to-cart
    form.querySelectorAll('[type="submit"], .product-form__submit').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const v = Number(qty.value || 0);
        if (v < 25) {
          e.preventDefault();
          alert('Minimum order for this product is 25.');
          qty.value = 25;
          qty.dispatchEvent(new Event('change'));
        }
      });
    });
  };

  // Run now, and re-run when Zepto / theme re-renders the section
  applyMOQ();
  document.addEventListener('shopify:section:load', applyMOQ);

  // Zepto injects DOM nodes after load — watch for changes and re-apply
  new MutationObserver(applyMOQ).observe(document.body, { childList: true, subtree: true });
})();
